/**
 * Pick a language-keyed config entry (object, array, or string).
 * Falls back to en, then tr, when the active language is missing.
 */
export const resolveLocalizedValue = (map, lang) => {
    if (map == null || typeof map !== 'object') {
        return undefined;
    }
    if (map[lang] != null && map[lang] !== '') {
        return map[lang];
    }
    if (map.en != null && map.en !== '') {
        return map.en;
    }
    if (map.tr != null && map.tr !== '') {
        return map.tr;
    }
    return undefined;
};

/**
 * Resolve a config string that may be language-keyed.
 *
 * Supports:
 *   - plain string (legacy) → returned as-is for every language
 *   - { en: '...', tr: '...', ... } → pick lang, fall back to en, then first string value
 */
const resolveLocalizedString = (value, lang) => {
    if (value == null || value === '') {
        return '';
    }
    if (typeof value === 'string') {
        return value;
    }
    if (typeof value !== 'object') {
        return '';
    }
    if (typeof value[lang] === 'string' && value[lang]) {
        return value[lang];
    }
    if (typeof value.en === 'string' && value.en) {
        return value.en;
    }
    const first = Object.values(value).find((v) => typeof v === 'string' && v);
    return first || '';
};

export default resolveLocalizedString;
